import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { optionsType, PredefinedDataTypes } from "../utils/formTypes";
import usePredefinedDataByType from "../customHooks/usePredefinedType";
import {
  FormAutocomplete,
  formClasses,
  labelClasses,
  LabeledAutocomplete,
} from "../styles/AutocompleteStyles";
import {
  handleMUISelectEvent,
  isOptionEqualToValue,
} from "../utils/UtilFunctions";
import { Keys } from "../utils/Enum.keys";
interface Props {
  type: PredefinedDataTypes;
  value: string;
  onChange: (newValue: optionsType | null, type: PredefinedDataTypes) => void;
  label: string;
  disabled?: boolean;
  edit?: boolean;
}
const PredefinedAutocomplete = ({
  type,
  value,
  onChange,
  label,
  disabled,
  edit,
}: Props) => {
  const [searchData, setSearchData] = useState("");

  const [autoValue, setAutoValue] = useState<optionsType | null>(null);

  const {
    PredefinedData: { dropDown, data, handleScroll },
  } = usePredefinedDataByType(type, searchData);

  useEffect(() => {
    if (edit && value) {
      setSearchData(value);
    }
  }, [value]);

  useEffect(() => {
    if (value) {
      const foundValue = dropDown.find(
        ({ value: optionsValue }) => optionsValue === value
      );

      setAutoValue(foundValue ? foundValue : null);
    } else {
      setAutoValue(null);
    }
  }, [value, data, dropDown]);

  const commonAutocompleteProps = {
    className: label ? labelClasses.inputRoot : formClasses.inputRoot,
    options: dropDown,
    openOnFocus: true,
    ListboxProps: {
      onScroll: handleScroll,
    },
    disabled: disabled,
    onChange: (e: React.SyntheticEvent<Element, Event>, value: unknown) =>
      onChange(value as optionsType, type),
  };

  const commonTextFieldProps = {
    onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
      setSearchData(e.target.value),
    label: label || "",
    fullWidth: true,
    InputLabelProps: { shrink: label.length > 0 },
    className: label
      ? labelClasses.formControlRoot
      : formClasses.formControlRoot,
  };

  const Autocomplete =
    label.length > 0 ? LabeledAutocomplete : FormAutocomplete;

  return (
    <Autocomplete
      {...commonAutocompleteProps}
      {...(value ? { value: autoValue } : {})}
      value={autoValue}
      // Conditional value
      isOptionEqualToValue={(option) =>
        isOptionEqualToValue(option as optionsType, autoValue)
      }
      onKeyDown={(e) => {
        if (e.key === Keys.ENTER) {
          handleMUISelectEvent(e);
        }
      }}
      // autoComplete={false}
      renderInput={(params) => (
        <TextField
          {...params}
          {...commonTextFieldProps}
          autoComplete="one-time-code"
        />
      )}
    />
  );
};

export default PredefinedAutocomplete;
